import { render, staticRenderFns } from "./EducationInfo.vue?vue&type=template&id=5783ca98&scoped=true&"
import script from "./EducationInfo.vue?vue&type=script&lang=js&"
export * from "./EducationInfo.vue?vue&type=script&lang=js&"
import style0 from "./EducationInfo.vue?vue&type=style&index=0&id=5783ca98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5783ca98",
  null
  
)

export default component.exports